import { cn } from "@/lib/utils"

interface ChallengeContentProps {
  className?: string
  children: React.ReactNode
}

export default function ChallengeContent({ className, children }: ChallengeContentProps) {
  return <div className={cn("flex h-full w-full justify-center", className)}>{children}</div>
}
